import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { firstValueFrom } from 'rxjs';
import { Feature } from '../models/entities/feature';

@Injectable({
  providedIn: 'root',
})
export class FeaturesService {
  features: Feature[] = [];
  constructor(private apiService: ApiService) {}

  async findAndSet(): Promise<void> {
    const featuresResponse = await firstValueFrom(
      this.apiService.get('features'),
    );
    this.features = featuresResponse.data;
  }
}
